import React, { useEffect, useMemo, useRef } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './Timeline.css';

const Timeline = ({
  points = [],
  selectedIndex,
  onSelect,
  darkMode,
  distanceLabel
}) => {
  const selectedRef = useRef(null);

  const middleIndex = useMemo(() => {
    if (points.length < 2) return 0;
    return Math.floor((points.length - 1) / 2);
  }, [points.length]);

  useEffect(() => {
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [selectedIndex]);

  if (!points.length) return null;

  const selectedData =
    selectedIndex != null ? points[selectedIndex]?.properties?.data : null;
  const canOpenMaps =
    selectedData &&
    Number.isFinite(selectedData.lat) &&
    Number.isFinite(selectedData.lng);

  return (
    <div className={`maps-tracking-bottom ${darkMode ? 'dark' : 'light'}`}>
      <Card className={`maps-tracking-bottom-card ${darkMode ? 'dark' : ''}`}>
        <Card.Body>
          <div className="maps-tracking-bottom__row">
            <div className="maps-tracking-timeline__controls">
              <button
                type="button"
                className="maps-tracking-timeline__quick"
                onClick={() => onSelect(0)}
              >
                Início
              </button>
              <button
                type="button"
                className="maps-tracking-timeline__quick"
                onClick={() => onSelect(middleIndex)}
                disabled={points.length < 2}
              >
                Meio
              </button>
              <button
                type="button"
                className="maps-tracking-timeline__quick"
                onClick={() => onSelect(points.length - 1)}
              >
                Fim
              </button>
            </div>

            <div className="maps-tracking-timeline__track-wrap">
              <div className="maps-tracking-timeline__line" aria-hidden="true" />
              <div className="maps-tracking-timeline__points">
                {points.map((point, index) => {
                  const data = point.properties.data;
                  const isSelected = index === selectedIndex;
                  const isStart = index === 0;
                  const isEnd = index === points.length - 1;

                  return (
                    <button
                      key={point.properties.id}
                      type="button"
                      ref={isSelected ? selectedRef : null}
                      className={[
                        'maps-tracking-timeline__dot',
                        isSelected ? 'is-selected' : '',
                        isStart ? 'is-start' : '',
                        isEnd ? 'is-end' : ''
                      ]
                        .filter(Boolean)
                        .join(' ')}
                      title={`Ponto ${data.order}${data.date ? ` — ${data.date}` : ''}`}
                      onClick={() => onSelect(index)}
                    >
                      <span>{data.order}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {distanceLabel ? (
              <div className="maps-tracking-bottom__distance">
                <strong>{distanceLabel}</strong>
              </div>
            ) : null}

            <Button
              size="sm"
              variant={darkMode ? 'outline-light' : 'outline-secondary'}
              className="maps-tracking-bottom__maps-btn"
              disabled={!canOpenMaps}
              onClick={() => {
                if (!canOpenMaps) return;
                window.open(
                  `https://www.google.com/maps?q=${selectedData.lat},${selectedData.lng}`,
                  '_blank'
                );
              }}
              title="Abrir no Google Maps"
            >
              <FaMapMarkerAlt />
            </Button>
          </div>

          <div className="maps-tracking-bottom__details">
            {selectedData ? (
              <div className="maps-tracking-bottom__details-line">
                <span>
                  <strong>#{selectedData.order}</strong> {selectedData.serial}
                </span>
                <span>{selectedData.date}</span>
                <span>{selectedData.grain}</span>
                <span>Umid. {selectedData.humidity}</span>
                <span>Temp. {selectedData.temperature}</span>
                <span>
                  {selectedData.city} / {selectedData.state}
                </span>
                {selectedData.email ? <span>{selectedData.email}</span> : null}
              </div>
            ) : (
              <div className="maps-tracking-bottom__empty">
                Selecione um ponto na linha
              </div>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Timeline;
